export default __webpack_public_path__ + "assets/f5fb0fff076920bf8c2e49dd61dd870d.jpeg";